import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Umami automatically tracks page views for SPAs
    // No additional configuration needed for basic page tracking
  }, [location]);
}

export default usePageTracking; 